import api from './client'


export const participantApi = {
  getEvents: (params) => api.get('/participant/events', { params }),
  getEvent: (eventId) => api.get(`/events/${eventId}`),
  getApplications: (params) => api.get('/participant/applications', { params }),
  getApplication: (applicationId) => api.get(`/applications/${applicationId}`),
  createApplication: (eventId, data) => api.post(`/events/${eventId}/applications`, data),
  updateApplication: (applicationId, data) => api.put(`/applications/${applicationId}`, data),
  deleteApplication: (applicationId) => api.delete(`/applications/${applicationId}`)
}
